import type { Theme } from "@nivo/core"

export const nivoTheme: Theme = {
  axis: {
    ticks: {
      text: {
        fill: "light-dark(#333, #fff)",
      },
    },
  },
  tooltip: {
    container: {
      background: "light-dark(#fff, #333)",
      color: "light-dark(#6c757d, #fff)",
    },
  },
}
